import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferencedText = _resolveComponent("ReferencedText")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSubHeading, {
      class: _normalizeClass(["read-more_content", _ctx.className]),
      style: _normalizeStyle({ height: _ctx.styleHeight }),
      size: _ctx.size,
      weight: _ctx.weight
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", { ref: _ctx.ref }, [
          _renderSlot(_ctx.$slots, "text", {}, () => [
            _createVNode(_component_ReferencedText, { html: _ctx.text }, null, 8, ["html"])
          ])
        ], 512)
      ]),
      _: 3
    }, 8, ["class", "style", "size", "weight"]),
    (_ctx.addReadMore)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "link is-medium-500 read-more_button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleReadMore && _ctx.toggleReadMore(...args)))
        }, _toDisplayString(_ctx.readMoreLabel), 1))
      : _createCommentVNode("", true)
  ], 64))
}